// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"255":"e2c7b98f","415":"4ba1b34c","936":"b6cf845e","942":"72d78085"}[chunkId] + ".chunk.js";
};